import { api } from './client';
import axios from 'axios';

export const createOrder = (data: unknown) =>
  api.post('/orders', data).then(r => r.data.data);

export const getMyOrders = () =>
  api.get('/orders/my').then(r => r.data.data);

export const getOrder = (id: string) =>
  api.get(`/orders/${id}`).then(r => r.data.data);

export const createRazorpayOrder = (orderId: string) =>
  api.post('/payments/create', { orderId }).then(r => r.data.data);

export const verifyPayment = (data: {
  orderId: string;
  razorpayOrderId: string;
  razorpayPaymentId: string;
  razorpaySignature: string;
}) => api.post('/payments/verify', data).then(r => r.data.data);

// Admin
export const adminGetOrders = (params?: Record<string, string>) =>
  api.get('/admin/orders', { params }).then(r => r.data.data);

export const adminGetOrder = (id: string) =>
  api.get(`/admin/orders/${id}`).then(r => r.data.data);

export const adminUpdateOrder = (id: string, data: unknown) =>
  api.put(`/admin/orders/${id}`, data).then(r => r.data.data);
